export interface PowerPointClientUpdateBusyInput {
  /** Whether any chat tab still reports an active run. */
  hasLoadingTab: boolean;
  /** Whether the shared registry contains thinking, apply, or replacement work. */
  hasInFlightHostWork: boolean;
  /** Whether a deck creation operation is active. */
  isCreatingDeck: boolean;
  /** Whether the matching-Skill banner awaits a user decision. */
  hasPendingSkillDecision: boolean;
  /** Whether Review has an open or remembered plan. */
  hasPendingReview: boolean;
  /** Whether an asynchronous Review operation remains active. */
  hasReviewActivity: boolean;
}

/**
 * Reports whether reloading would interrupt PowerPoint work or a decision.
 *
 * @param input - Live query, host-operation, deck, Skill, and Review state.
 * @returns `true` while any operation or user decision remains pending.
 * @throws Never.
 */
export function isPowerPointClientUpdateBusy(
  input: PowerPointClientUpdateBusyInput
): boolean {
  return Object.values(input).some(Boolean);
}
